import { NavLink } from 'react-router-dom';

// 主导航配置集中放在数组中，新增页面时只需要追加一项。
const navItems = [
  { to: '/fashion', label: 'Fashion' },
  { to: '/art', label: 'Art' },
  { to: '/writing', label: 'Writing' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' }
];

export default function Header() {
  return (
    <header className="header">
      <nav className="nav">
        {/* NavLink 会自动给当前路由加 active class，样式在 src/styles/app.css 中处理。 */}
        <NavLink to="/" className="nav-brand" aria-label="Evacuate from Meaning home">
          <img
            loading="eager"
            decoding="async"
            src="/assets/logo.png"
            alt="Evacuate from Meaning"
            className="logo"
          />
          <span className="brand-name">Evacuate from Meaning</span>
        </NavLink>
        <div className="nav-links">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </header>
  );
}
